<template>
  <div>
    <Header go-back />
    <div>
      <div class="row no-gutters">
        <aside class="col-sm-12">
          <div v-if="!loaded" class="p-2">
            <article class="gallery-wrap row">
              <div class="col-md-6">
                <content-placeholders class="w-100">
                  <content-placeholders-img style="height: 200px" />
                </content-placeholders>
                <div class="img-small-wrap">
                  <div class="item-gallery" v-for="i in 3" :key="i">
                    <content-placeholders class="w-100">
                      <content-placeholders-img />
                    </content-placeholders>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-5">
                  <h1 class="title mb-3 mt-4">
                    <content-placeholders>
                      <content-placeholders-heading />
                    </content-placeholders>
                  </h1>
                </div>

                <div>
                  <content-placeholders>
                    <content-placeholders-text :lines="5" />
                  </content-placeholders>
                </div>
              </div>
            </article>

            <dl class="mt-5 mb-5">
              <content-placeholders>
                <content-placeholders-text :lines="5" />
              </content-placeholders>
            </dl>
          </div>

          <article class="p-2" v-if="loaded">
            <article class="gallery-wrap row">
              <div class="col-md-6">
                <div v-if="loaded">
                  <div v-if="activeImage">
                    <inner-image-zoom :src="activeImage || defaultImage" />
                  </div>
                </div>
                <div class="img-small-wrap">
                  <div
                    class="item-gallery"
                    v-for="(img, i) in product.images"
                    :key="i"
                  >
                    <img :src="img.src" @click="activeImage = img.src" />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-5">
                  <h1 class="title mb-3 font-weight-bold">
                    {{ product.name }}
                  </h1>
                  <div class="mb-3 mt-3">
                    <div
                      class="price h3"
                      style="
                        font-size: 23px;
                        font-weight: bold;
                        color: var(--theme);
                      "
                    >
                      <span class="num" v-html="product.price_html"></span>
                    </div>
                  </div>
                </div>

                <div>
                  <h5 class="text-bold">Categorieën</h5>
                  <div class="flex flex-wrap">
                    <router-link
                      class="category-badge-link"
                      :to="`/category/${categ.id}`"
                      v-for="categ in product.categories"
                      :key="categ.id"
                    >
                      <span
                        class="badge badge-success badge-normal mr-2 mb-2"
                        >{{ categ.name }}</span
                      >
                    </router-link>
                  </div>
                </div>

                <div class="action-wrap mt-5 flex">
                  <QuantityInput
                    v-model="quantity"
                    :disabled="product.stock_status === 'outofstock'"
                  />
                  <button
                    class="btn btn-primary"
                    :disabled="product.stock_status === 'outofstock'"
                    @click="addToCartMulti(product)"
                  >
                    <i class="fas fa-shopping-cart"></i> Voeg toe aan winkelkar
                  </button>
                </div>
              </div>
            </article>

            <dl class="mt-5 mb-5">
              <h4 class="text-bold">Beschrijving</h4>
              <div class="description-container">
                <dd v-html="product.description"></dd>
              </div>
            </dl>

            <!-- <span class="btn btn-primary" @click="addToCart(product)">
              <i class="fas fa-shopping-cart"></i> Voeg toe aan winkelkar
            </span> -->
          </article>
        </aside>
      </div>
    </div>
    <div v-if="relatedProducts.length" class="related-products-wrap">
      <h1 class="text-center font-weight-bold">Gerelateerde producten</h1>
      <div class="row">
        <ProductCard
          class="col-sm-3"
          v-for="product in relatedProducts"
          :key="product.id"
          :product="product"
        />
      </div>
    </div>
    <transition name="fade">
      <AddingPopupWindow :productName="product.name" v-if="showAddProduct" />
    </transition>
  </div>
</template>

<script>
import ProductCard from "@/components/ProductCard";
import WooCommerce from "@/services/wooservice.js";
import QuantityInput from "@/components/QuantityInput";
import Header from "@/components/Header";
import { mapActions } from "vuex";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";
import AddingPopupWindow from "@/components/AddingPopupWindow";

export default {
  name: "ProductPage",
  components: {
    Header,
    "inner-image-zoom": InnerImageZoom,
    AddingPopupWindow,
    QuantityInput,
    ProductCard,
  },

  data() {
    return {
      product: {},
      relatedProducts: [],
      activeImage: "",
      loaded: false,
      showAddProduct: false,
      quantity: 1,
      lastProductId: null,
      toFetch: true,
      counter: 0,
    };
  },

  methods: {
    ...mapActions("cart", ["addToCart"]),
    addToCartMulti(product) {
      this.showAddProduct = true;
      for (let i = 1; i <= this.quantity; i++) {
        this.addToCart(product);
      }
      setTimeout(() => (this.showAddProduct = false), 3000);
    },

    async getProduct(id) {
      const response = await WooCommerce.get("products/" + id);

      this.product = response.data;
      this.activeImage = this.product.images[0].src;
      this.product.categories = this.product.categories.map((cat) => {
        cat.name = cat.name
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&amp;/g, "&");
        return cat;
      });
      this.loaded = true;

      const relatedProducts = await WooCommerce.get("products", {
        include: response.data.related_ids,
        per_page: 4,
      });
      this.relatedProducts = relatedProducts.data;
    },
  },

  beforeRouteUpdate(to, from, next) {
    if (from.params.id !== to.params.id) {
      this.getProduct(to.params.id);
      this.lastProductId = to.params.id;
      next();
    } else {
      this.toFetch = true;
    }
  },

  created() {
    if (this.toFetch) {
      this.getProduct(this.$route.params.id);
    }
  },
};
</script>
<style>
.related-products-wrap {
  background-color: #eee;
  padding: 3rem;
}

.category-badge-link .badge:hover {
  text-decoration: underline;
}

.shop-star {
  color: #eade30;
}

.description-container .col-md-6,
.description-container .col-sm-3,
.description-container .col-lg-4 {
  max-width: 100%;
  flex: unset;
}

.description-container h1 {
  font-size: unset;
}

.description-container strong {
  margin-right: 10px;
}

.description-container .row {
  margin-left: unset;
}
</style>
